<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<!--클레임번호-->
					<clam-mst-search-input
						:label="getMessage_('QWCC001225')"
						paramKey="clmNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--Ro 번호-->
					<clam-mst-search-input
						:label="getMessage_('QWCC000976')"
						paramKey="roNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<!--딜러점-->
					<clam-mst-search-input
						:label="getMessage_('QWCC001341')"
						paramKey="dlrCpnyCd"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="3">
					<!--품번-->
					<clam-mst-search-input
						:label="getMessage_('QWCC000956')"
						paramKey="causPartNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="3">
					<!-- 캠페인번호-->
					<clam-mst-search-input :label="getMessage_('QWCC001024')" paramKey="cmpnNo" />
				</el-col>

				<!--ctype-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001056')"
						paramKey="ctype"
						:options="clmTypeList"
						:propData="searchParams.ctype"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="3">
					<!--처리단계-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000963') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcStepGb" @change="val => changeSelect(val, 'prcStepGb')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in prcsStepList" :key="option.commCd" :label="option.commCdName" :value="option.commCd">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>

				<el-col :span="3">
					<!--처리결과-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000978') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcRsltCd" @change="val => changeSelect(val, 'prcRsltCd')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in prcsRsltList" :key="option.commCd" :label="option.commCdName" :value="option.commCd">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>
				<el-col :span="3">
					<!--날짜구분-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001393') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcClmDd" @change="val => changeSelect(val, 'prcClmDd')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in clmDdList" :key="option.commCd" :label="option.commCdName" :value="option.commCd"> </el-option>
							</el-select>
						</div>
					</div>
				</el-col>

				<!--검색날짜-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001394')">
						<el-date-picker
							v-model="searchDcsnDdDt"
							@change="changeSearchDcsnDdDt"
							type="daterange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!-- <el-col :span="3">
						
					<search-input :label="getMessage_('QWCC001924')" paramKey="dlvgNm" @commInput="setSearchParam" :propData="searchParams.dlvgNm" />
				</el-col> -->
				<el-col :span="3">
					<!--품번-->
					<clam-mst-search-input
						:label="getMessage_('QWCC001924')"
						paramKey="dlvgNm"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/ClamMst/store/helpers';
import ClamMstSearchInput from './ClamMstSearchInput.vue';
import SelectCombo from '@qms/Components/SelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' } //클레임 승인현황에서 날짜 검색조건 가져옴
	},

	data() {
		return {
			searchDcsnDdDt: ['', '']
		};
	},
	components: { SelectCombo, ClamMstSearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_({ key: param.key, value: param.value });
		},
		changeSelect(val, key) {
			this.setSearchParam_({ key, value: val });
		},
		searchList() {
			this.$sf_toggleLoading(true);
			this.getClamMstList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchDcsnDdDt(data) {
			let from;
			let to;

			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			} else {
				from = '';
				to = '';
			}

			this.searchDcsnDdDt = [from, to];
			this.setSearchParam_({ key: 'startDcsnDd', value: from });
			this.setSearchParam_({ key: 'endDcsnDd', value: to });
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'prcsStepList', codeType: 'PRCS_STEP_01' });
			await this.getCommCodes_({ key: 'prcsRsltList', codeType: 'PRCS_RSLT_01' });
			await this.getCommCodes_({ key: 'clmDdList', codeType: 'CLM_DD' });
			await this.getCommCodes_({ key: 'clmTypeList', codeType: 'CLM_TYPE' });

			//state안에 초기화 되어있는 값을 개터스 함수로 꺼내서 셋팅한다.

			/*클레임 승인내역에서 넘어오는 파라미터 값 시작*/
			let pStartDt = this.pStartDt || '';
			let pEndDt = this.pEndDt || '';
			let pState1 = this.pState1 || ''; // 처리단계
			let pState2 = this.pState2 || ''; // 처리결과
			let pState3 = this.pState3 || ''; // 날짜 검색조건

			pStartDt = pStartDt != '' ? this.$moment(pStartDt).format('YYYY-MM-DD') : '';
			pEndDt = pEndDt != '' ? this.$moment(pEndDt).format('YYYY-MM-DD') : '';

			//console.log('argsState1 >>>>>>', pState1);
			//console.log('argsState2 >>>>>>', pState2);
			//console.log('argsState3 >>>>>>', pState3);
			//console.log('pStartDt >>>>>>', pStartDt);
			//console.log('pEnddt >>>>>>', pEndDt);

			//해당부분 초기화
			this.setSearchParam_({ key: 'prcRsltCd', value: '' });
			this.setSearchParam_({ key: 'prcStepGb', value: '' });
			this.setSearchParam_({ key: 'prcClmDd', value: '' });
			this.setSearchParam_({ key: 'startDcsnDd', value: '' });
			this.setSearchParam_({ key: 'endDcsnDd', value: '' });

			if (pState1 != '' && pState2 == '' && pState3 == '') {
				this.searchDcsnDdDt = [pStartDt, pEndDt];
				this.setSearchParam_({ key: 'prcRsltCd', value: pState1 });
				this.setSearchParam_({ key: 'startDcsnDd', value: pStartDt });
				this.setSearchParam_({ key: 'endDcsnDd', value: pEndDt });
			} else if (pState2 != '' && pState1 == '' && pState3 == '') {
				this.searchDcsnDdDt = [pStartDt, pEndDt];
				this.setSearchParam_({ key: 'prcStepGb', value: pState2 });
				this.setSearchParam_({ key: 'startDcsnDd', value: pStartDt });
				this.setSearchParam_({ key: 'endDcsnDd', value: pEndDt });
			} else if (pState3 != '' && pState2 != '' && pState1 == '') {
				this.searchDcsnDdDt = [pStartDt, pEndDt];
				this.setSearchParam_({ key: 'prcStepGb', value: pState2 });
				this.setSearchParam_({ key: 'prcClmDd', value: pState3 });

				this.setSearchParam_({ key: 'startDcsnDd', value: pStartDt });
				this.setSearchParam_({ key: 'endDcsnDd', value: pEndDt });
			} else {
				//월말 월초로 초기값셋팅
				this.searchDcsnDdDt = [this.getStartInitDd_, this.getEndInitDd_];
				this.setSearchParam_({ key: 'prcClmDd', value: '' });
				this.setSearchParam_({ key: 'startDcsnDd', value: this.getStartInitDd_ });
				this.setSearchParam_({ key: 'endDcsnDd', value: this.getEndInitDd_ });
			}

			//검색 스테이트변수는 이미 셋팅되어 있으므로 화면에 data부에 값을 셋팅한다.
			//this.$refs.rdoClmSelect1.processInfo();
			//this.$refs.rdoClmSelect2.processInfo();
			//this.$refs.rdoClmSelect3.processInfo();

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
